var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item-avatar',{staticClass:"social-network"},[_c('v-icon',{staticClass:"white--text",class:_vm.avatar.icon.class},[_vm._v(_vm._s(_vm.avatar.icon.value))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }